import axiosInstance from './axiosInstance';

const agentService = {
    // Test connection
    testConnection() {
        return axiosInstance.get('/agents/test');
    },

    // Get all agents
    async getAllAgents() {
        try {
            const response = await axiosInstance.get('/agents');
            return response.data;
        } catch (error) {
            console.error('Error fetching agents:', error);
            throw error.response?.data || error.message;
        }
    },

    // Get single agent by ID
    async getAgentById(id) {
        try {
            const response = await axiosInstance.get(`/agents/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create new agent
    async createAgent(agentData) {
        try {
            const response = await axiosInstance.post('/agents', agentData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update agent
    async updateAgent(id, agentData) {
        try {
            const response = await axiosInstance.put(`/agents/${id}`, agentData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Toggle agent status
    async toggleAgentStatus(id) {
        try {
            const response = await axiosInstance.patch(`/agents/${id}/toggle-status`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete agent
    async deleteAgent(id) {
        try {
            const response = await axiosInstance.delete(`/agents/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};

export default agentService; 